import { LegacyIIQApi } from '../legacy-iiq-api';

export const getRoleUsers =
  ({ legacyIIQApi: api }: { legacyIIQApi: LegacyIIQApi }) =>
  ({ id }: { id: string }) =>
    api.get(`/roles/${id}/users`).then((res) => res.data);
